var clickOutside = function (element, callback) {
    var clicked = false;
    document.addEventListener('click', function (event) {
        if (!element.contains(event.target) && !clicked) {
            callback();
        }
        clicked = element.contains(event.target);
    }, true);
};

var isFunction = function (value) {
    return typeof value === 'function';
};

var isUndefined = function (value) {
    return value === undefined;
};

var isNil = function (value) {
    return value == null || value === undefined;
};

var isString = function (value) {
    return typeof value === 'string';
};

var replaceAll = function (str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
};

function throttle(callback, wait, _a) {
    if (wait === void 0) { wait = 0; }
    var _b = _a === void 0 ? {} : _a, _c = _b.start, start = _c === void 0 ? true : _c, _d = _b.middle, middle = _d === void 0 ? true : _d, _e = _b.once, once = _e === void 0 ? false : _e;
    var innerStart = start;
    var last = 0;
    var timer;
    var cancelled = false;
    function fn() {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (cancelled)
            return;
        var delta = Date.now() - last;
        last = Date.now();
        if (start && middle && delta >= wait) {
            innerStart = true;
        }
        if (innerStart) {
            innerStart = false;
            callback.apply(this, args);
            if (once)
                fn.cancel();
        }
        else if ((middle && delta < wait) || !middle) {
            clearTimeout(timer);
            timer = setTimeout(function () {
                last = Date.now();
                callback.apply(_this, args);
                if (once)
                    fn.cancel();
            }, !middle ? wait : wait - delta);
        }
    }
    fn.cancel = function () {
        clearTimeout(timer);
        cancelled = true;
    };
    return fn;
}
function debounce(callback, wait, _a) {
    if (wait === void 0) { wait = 0; }
    var _b = _a === void 0 ? {} : _a, _c = _b.start, start = _c === void 0 ? false : _c, _d = _b.middle, middle = _d === void 0 ? false : _d, _e = _b.once, once = _e === void 0 ? false : _e;
    return throttle(callback, wait, { start: start, middle: middle, once: once });
}

var removeHtmlTags = function (str) {
    return str.replace(/(<([^>]+)>)/gi, '');
};

var stringToJson = function (str) {
    try {
        var result = JSON.parse(str);
        if (Array.isArray(result)) {
            return result;
        }
        else {
            return [];
        }
    }
    catch (e) {
        return [];
    }
};

var objectToQueryString = function (object, prefix) {
    if (prefix === void 0) { prefix = ''; }
    return (prefix +
        Object.keys(object)
            .map(function (key) {
            return "".concat(key, "=").concat(object[key]);
        })
            .join('&'));
};

var splitArray = function (arr, size) {
    var result = [];
    for (var i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
    }
    return result;
};

export { clickOutside, debounce, isFunction, isNil, isString, isUndefined, objectToQueryString, removeHtmlTags, replaceAll, splitArray, stringToJson, throttle };
//# sourceMappingURL=index.esm.js.map
